<i18n src="../../locales/lang.json"></i18n>

<template>
  <ul class="">
    <li class="nav-item" :key="el.Id" v-for="el in realValue" v-bind:class="{'nav-item-submenu':el.Elements.length > 0,'nav-item-expanded nav-item-open': el.expanded == true}">
      <a class="nav-link skin admintextcolor" v-if="el.Elements.length > 0" href="#" @click="expand(el)">
        <i v-bind:class="el.Icon"></i>
        <span v-bind:style="{'color:green !important;':el.selected == true}">{{el.Text}}</span>
      </a>
      <a class="nav-link skin admintextcolor" v-if="el.Elements.length == 0" href="#" @click="clickItem(el)" v-bind:class="{'active skin adminmenu-active':el.selected == true}" style="color:inherit">
        <i v-show="el.Icon != null && typeof(el.Icon) != 'undefined'" v-bind:class="el.Icon"></i>
        <span v-bind:style="{'color:green !important;':el.selected == true}">{{el.Text}}</span>
      </a>
      <menu-item class="nav nav-group-sub skin adminmenu-expandoverlay-bg" v-show="el.expanded == true" v-model="el.Elements" @expanditem="expand" @clickItem="clickItem" />
    </li>
  </ul>

</template>

<script>
  /*import { formatIsoTimeString } from "../../../../global_assets/js/plugins/ui/fullcalendar/main";*/


  var overelement = null;
  var expanded = false;

  export default {
    name: "menu-item",
    components: {

    },
    data() {
      return {
        overelement,
        expanded
      }
    },
    methods: {
      expand(el) {
        el.expanded = !el.expanded;
        this.$emit('expanditem', el);
        this.$forceUpdate();

        if (el.expanded && el.Elements.length > 0) {
          var childEl = el.Elements[0];
          childEl.selected = true;
          this.$emit('multipleClickItem', childEl);
        }
      },
      clickItem(el) {
        el.selected = true;
        this.$emit('clickItem', el);
      },
      getParent(element) {

      },
      handleRefresh(selected) {
        for (var i = 0; i < this.realValue.length; i++) {
          if (this.realValue[i] != selected) {
            this.realValue[i].selected = false;
          }

          if (this.realValue[i].length > 0) {
            var childs = this.realValue[i];
            for (var j = 0; j < childs.length; j++) {
              if (childs[j] != selected) {
                childs[j].selected = false;
              }
            }
          }

        }
        this.$forceUpdate();
      },
    },
    components: {

    },
    computed: {

      realValue() {
        return this.value ? this.value : this.list;
      },

    },
    props: {
      value: {
        required: false,
        type: Array,
        default: null
      },
      list: {
        required: false,
        type: Array,
        default: null
      },
    },
    mounted() {
      this.$root.$on('menu-item-selected', this.handleRefresh);
    }
  };
</script>

<style scoped>
  .sidebar-dark .nav-sidebar > .nav-item-submenu > .nav-group-sub {
    background-color: rgba(255,255,255,.50);
  }

  .sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .nav-sidebar .nav-item-header, .sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .nav-sidebar .nav-link, .sidebar-expand-lg.sidebar-main-resized:not(.sidebar-main-unfold) .sidebar-main-header {
    padding-left: 6px;
    padding-right: 0;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .nav-sidebar .nav-item:not(.nav-item-header):last-child {
    padding-bottom: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/navigation/menu-item.vue